import { Navigate, Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/side-navigation/side-navigation.component";
import Spinner from "../components/spinner/spinner.component";
import { useSession } from "../queries/auth.queries";

export default function ProtectedRoute() {
	const { data: session, isLoading, isFetching } = useSession();
	const location = useLocation();

	// After logout, setQueryData(null) leaves the query in success+null state.
	// invalidateQueries (triggered by useLogin) starts a background refetch but
	// doesn't block navigate("/") — so ProtectedRoute can render with
	// isLoading=false, session=null while the refetch is still in flight.
	// Wait for it rather than bouncing the user back to /login prematurely.
	if (isLoading || (session === null && isFetching)) return <Spinner styles={undefined} />;
	if (!session) return <Navigate to="/login" state={{ from: location }} replace />;
	if (!session.company_verified) return <Navigate to="/verification" replace />;

	return (
		<Sidebar>
			<Outlet />
		</Sidebar>
	);
}
